<td colspan="2"></td>
<td>Abruf {{ fetch.ordering }}</td>
<td>{{ fetch.date_delivery|date:'dd.MM.yyyy' }}</td>
<td>{{ fetch.order_nr ?? '' }}</td>
<td class="icon"></td>
<td colspan="5"></td>
